/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import { CloseCircleFilledIcon } from 'tdesign-icons-react';
import { i as isFunction_1 } from '../_chunks/dep-f10515e8.js';
import classNames from 'classnames';
import useConfig from '../hooks/useConfig.js';
import useGlobalIcon from '../hooks/useGlobalIcon.js';
import useDragSorter from '../_util/useDragSorter.js';
import { Input } from '../input/index.js';
import useTagScroll from './useTagScroll.js';
import useTagList from './useTagList.js';
import useHover from './useHover.js';
import useControlled from '../hooks/useControlled.js';
import { tagInputDefaultProps } from './defaultProps.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../input/Input.js';
import '../_chunks/dep-92728dc5.js';
import '../_util/useLayoutEffect.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_util/easing.js';
import '../_util/forwardRefWithStatics.js';
import 'hoist-non-react-statics';
import '../input/InputGroup.js';
import '../locale/LocalReceiver.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../input/defaultProps.js';
import '../_util/parseTNode.js';
import '../input/useLengthLimit.js';
import '../_common/js/log/index.js';
import '../_common/js/log/log.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-c1f93350.js';
import '../_util/noop.js';
import '../input/style/css.js';
import '../input/type.js';
import '../tag/index.js';
import '../tag/Tag.js';
import '../tag/CheckTag.js';
import '../tag/defaultProps.js';
import '../tag/style/css.js';
import '../tag/type.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TagInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var _ref;
  var _useConfig = useConfig(),
    prefix = _useConfig.classPrefix;
  var _useGlobalIcon = useGlobalIcon({
      CloseCircleFilledIcon: CloseCircleFilledIcon
    }),
    CloseCircleFilledIcon$1 = _useGlobalIcon.CloseCircleFilledIcon;
  var excessTagsDisplayType = props.excessTagsDisplayType,
    autoWidth = props.autoWidth,
    readonly = props.readonly,
    disabled = props.disabled,
    clearable = props.clearable,
    placeholder = props.placeholder,
    valueDisplay = props.valueDisplay,
    label = props.label,
    inputProps = props.inputProps,
    size = props.size,
    tips = props.tips,
    status = props.status,
    suffixIcon = props.suffixIcon,
    suffix = props.suffix,
    onClick = props.onClick,
    onPaste = props.onPaste,
    _onFocus = props.onFocus,
    _onBlur = props.onBlur;
  var _useControlled = useControlled(props, "inputValue", props.onInputChange),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    tInputValue = _useControlled2[0],
    setTInputValue = _useControlled2[1];
  var _useHover = useHover(props),
    isHover = _useHover.isHover,
    addHover = _useHover.addHover,
    cancelHover = _useHover.cancelHover;
  var _useDragSorter = useDragSorter(_objectSpread(_objectSpread({}, props), {}, {
      sortOnDraggable: props.dragSort,
      onDragOverCheck: {
        x: true,
        targetClassNameRegExp: new RegExp("^".concat(prefix, "-tag"))
      }
    })),
    getDragProps = _useDragSorter.getDragProps;
  var isCompositionRef = useRef(false);
  var _useTagScroll = useTagScroll(props),
    scrollToRight = _useTagScroll.scrollToRight,
    onWheel = _useTagScroll.onWheel,
    scrollToRightOnEnter = _useTagScroll.scrollToRightOnEnter,
    scrollToLeftOnLeave = _useTagScroll.scrollToLeftOnLeave,
    tagInputRef = _useTagScroll.tagInputRef;
  var _useTagList = useTagList(_objectSpread(_objectSpread({}, props), {}, {
      getDragProps: getDragProps
    })),
    tagValue = _useTagList.tagValue,
    _onClose = _useTagList.onClose,
    onInnerEnter = _useTagList.onInnerEnter,
    onInputBackspaceKeyUp = _useTagList.onInputBackspaceKeyUp,
    clearAll = _useTagList.clearAll,
    renderLabel = _useTagList.renderLabel;
  var NAME_CLASS = "".concat(prefix, "-tag-input");
  var WITH_SUFFIX_ICON_CLASS = "".concat(prefix, "-tag-input__with-suffix-icon");
  var CLEAR_CLASS = "".concat(prefix, "-tag-input__suffix-clear");
  var BREAK_LINE_CLASS = "".concat(prefix, "-tag-input--break-line");
  var tagInputPlaceholder = !(tagValue !== null && tagValue !== void 0 && tagValue.length) ? placeholder : "";
  var showClearIcon = Boolean(!readonly && !disabled && clearable && isHover && (tagValue === null || tagValue === void 0 ? void 0 : tagValue.length));
  useImperativeHandle(ref, function () {
    return _objectSpread({}, tagInputRef.current || {});
  });
  var onInputCompositionstart = function onInputCompositionstart(value, context) {
    var _inputProps$onComposi;
    isCompositionRef.current = true;
    inputProps === null || inputProps === void 0 ? void 0 : (_inputProps$onComposi = inputProps.onCompositionstart) === null || _inputProps$onComposi === void 0 ? void 0 : _inputProps$onComposi.call(inputProps, value, context);
  };
  var onInputCompositionend = function onInputCompositionend(value, context) {
    var _inputProps$onComposi2;
    isCompositionRef.current = false;
    inputProps === null || inputProps === void 0 ? void 0 : (_inputProps$onComposi2 = inputProps.onCompositionend) === null || _inputProps$onComposi2 === void 0 ? void 0 : _inputProps$onComposi2.call(inputProps, value, context);
  };
  var onInputEnter = function onInputEnter(value, context) {
    setTInputValue("", {
      e: context.e,
      trigger: "enter"
    });
    !isCompositionRef.current && onInnerEnter(value, context);
    scrollToRight();
  };
  var onInnerClick = function onInnerClick(context) {
    if (!props.disabled && !props.readonly) {
      var _tagInputRef$current$, _tagInputRef$current$2;
      (_tagInputRef$current$ = tagInputRef.current.inputElement) === null || _tagInputRef$current$ === void 0 ? void 0 : (_tagInputRef$current$2 = _tagInputRef$current$.focus) === null || _tagInputRef$current$2 === void 0 ? void 0 : _tagInputRef$current$2.call(_tagInputRef$current$);
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(context);
  };
  var onClearClick = function onClearClick(e) {
    var _props$onClear;
    clearAll({
      e: e
    });
    setTInputValue("", {
      e: e,
      trigger: "clear"
    });
    (_props$onClear = props.onClear) === null || _props$onClear === void 0 ? void 0 : _props$onClear.call(props, {
      e: e
    });
  };
  var suffixIconNode = showClearIcon ? /* @__PURE__ */React.createElement(CloseCircleFilledIcon$1, {
    className: CLEAR_CLASS,
    onClick: onClearClick
  }) : suffixIcon;
  var displayNode = isFunction_1(valueDisplay) ? valueDisplay({
    value: tagValue,
    onClose: function onClose(index, item) {
      return _onClose({
        index: index,
        item: item
      });
    }
  }) : valueDisplay;
  var isEmpty = !(Array.isArray(tagValue) && tagValue.length);
  var classes = [NAME_CLASS, (_ref = {}, _defineProperty(_ref, BREAK_LINE_CLASS, excessTagsDisplayType === "break-line"), _defineProperty(_ref, WITH_SUFFIX_ICON_CLASS, !!suffixIconNode), _defineProperty(_ref, "".concat(prefix, "-is-empty"), isEmpty), _defineProperty(_ref, "".concat(prefix, "-tag-input--with-tag"), !isEmpty), _ref), props.className];
  return /* @__PURE__ */React.createElement(Input, _objectSpread({
    ref: tagInputRef,
    value: tInputValue,
    onChange: function onChange(val, context) {
      setTInputValue(val, _objectSpread(_objectSpread({}, context), {}, {
        trigger: "input"
      }));
    },
    autoWidth: true,
    onWheel: onWheel,
    size: size,
    readonly: readonly,
    disabled: disabled,
    label: renderLabel({
      displayNode: displayNode,
      label: label
    }),
    className: classNames(classes),
    style: props.style,
    tips: tips,
    status: status,
    placeholder: tagInputPlaceholder,
    suffix: suffix,
    suffixIcon: suffixIconNode,
    showInput: !(inputProps !== null && inputProps !== void 0 && inputProps.readonly) || !tagValue || !(tagValue !== null && tagValue !== void 0 && tagValue.length),
    keepWrapperWidth: !autoWidth,
    onPaste: onPaste,
    onClick: onInnerClick,
    onEnter: onInputEnter,
    onKeydown: onInputBackspaceKeyUp,
    onMouseenter: function onMouseenter(context) {
      addHover(context);
      scrollToRightOnEnter();
    },
    onMouseleave: function onMouseleave(context) {
      cancelHover(context);
      scrollToLeftOnLeave();
    },
    onFocus: function onFocus(inputValue, context) {
      _onFocus === null || _onFocus === void 0 ? void 0 : _onFocus(tagValue, {
        e: context.e,
        inputValue: inputValue
      });
    },
    onBlur: function onBlur(inputValue, context) {
      if (tInputValue) {
        setTInputValue("", {
          e: context.e,
          trigger: "blur"
        });
      }
      _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(tagValue, {
        e: context.e,
        inputValue: ""
      });
    },
    onCompositionstart: onInputCompositionstart,
    onCompositionend: onInputCompositionend
  }, inputProps));
});
TagInput.displayName = "TagInput";
TagInput.defaultProps = tagInputDefaultProps;

export { TagInput as default };
//# sourceMappingURL=TagInput.js.map
